import { render, staticRenderFns } from "./GoBackBtn.vue?vue&type=template&id=506ee56c&scoped=true"
import script from "./GoBackBtn.vue?vue&type=script&lang=js"
export * from "./GoBackBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506ee56c",
  null
  
)

export default component.exports